import React, { useContext, useEffect, useRef, useState } from 'react';
import { useUserContext } from './user_context';
import { createSocket } from '../api/createSocket';
import { toast } from 'react-toastify';

export const WebSocketContext = React.createContext();

export const WebSocketProvider = ({ children }) => {
    const { btoken, stoken, usertoken } = useUserContext();
    const socketRef = useRef(null);

    const [notifications, setNotifications] = useState([]);
    const [notificationBadge, setNotificationBadge] = useState(false);
    useEffect(() => {
        if (!btoken || !stoken || !usertoken) return;

        const ws = createSocket({
            headers: { btoken, stoken, usertoken },
        });

        socketRef.current = ws;

        ws.onopen = () => {
            console.log('✅ WebSocket connected');

            // Fetch unread notifications after connection
            ws.send(JSON.stringify({ type: 'notifications.get' }));
        };

        ws.onmessage = (event) => {
            try {
                const message = JSON.parse(event.data);

                if (Array.isArray(message) || message.data) {
                    if (message.type === 'notifications') {
                        const incoming = message.data || [];

                        if (incoming.length > 0) {
                            const groupedMessages = incoming.map(n => `🔔 ${ n.title || n.message }`).join('\n');
                            toast.success(groupedMessages, { autoClose: 5000, style: { whiteSpace: 'pre-line' } });
                        }
                        const stored = JSON.parse(localStorage.getItem('notifications')) || [];
                        const newNotifications = [...stored, ...(message.data || [])];
                        localStorage.setItem('notifications', JSON.stringify(newNotifications));
                        setNotifications(newNotifications);
                        setNotificationBadge(true);
                    }
                }

                console.log('📨 Message received:', message);
            } catch (error) {
                console.error('❌ Failed to parse WebSocket message:', error);
            }
        };


        ws.onerror = (error) => {
            console.error('⚠️ WebSocket error:', error);
        };

        ws.onclose = () => {
            console.log('❎ WebSocket connection closed');
        };

        // Send PING every 1 minutes
        const pingInterval = setInterval(() => {
            if (ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({ type: 'PING' }));
                console.log('📡 Sent PING');
            }
        }, 240000); // 4 minutes

        return () => {
            clearInterval(pingInterval);
            if (socketRef.current) {
                socketRef.current.close();
                socketRef.current = null;
                console.log('🧹 WebSocket cleaned up');
            }
        };
    }, [btoken, stoken, usertoken]);

    return (
        <WebSocketContext.Provider value={{ notifications, notificationBadge, setNotificationBadge }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
